export default {
    common: {
        done: "Fertig",
        duplicate: "Duplizieren",
        loading: "Laden...",
        loadingProducts: "Produkte werden geladen...",
        loadingPostalCodes: "Postleitzahlen werden geladen...",
        loadingRestaurantData: "Restaurantdaten werden geladen...",
        all: "Alle",
        save: "Speichern",
        saving: "Speichern...",
        cancel: "Abbrechen",
        delete: "Löschen",
        deleting: "Löschen...",
        edit: "Bearbeiten",
        add: "Hinzufügen",
        search: "Suchen",
        filter: "Filtern",
        reset: "Zurücksetzen",
        confirm: "Bestätigen",
        close: "Schließen",
        refresh: "Aktualisieren",
        back: "Zurück",
        next: "Weiter",
        previous: "Vorherige",
        first: "Erste",
        last: "Letzte",
        submit: "Absenden",
        yes: "Ja",
        no: "Nein",
        actions: "Aktionen",
        status: "Status",
        date: "Datum",
        time: "Zeit",
        minutes: "Minuten",
        name: "Name",
        description: "Beschreibung",
        price: "Preis",
        quantity: "Menge",
        total: "Gesamt",
        language: "Sprache",
        customer: "Kunde",
        company: "Unternehmen",
        view: "Ansehen",
        page: "Seite",
        update: "Aktualisieren",
        paymentStatus: "Zahlungsstatus",
        more: "Mehr",
        seeLess: "Weniger anzeigen",
        create: "Erstellen",
        title: "Titel",
        message: "Nachricht",
    },
    header: {
        profile: "Mein Konto",
        myRestaurant: "Mein Restaurant",
        changePassword: "Passwort ändern",
        logout: "Abmelden",
        administrator: "Administrator",
        restaurant: "Restaurant",
    },
    roles: {
        administrator: "ADMINISTRATOR",
        user: "BENUTZER",
        franchise: "FRANCHISE",
        restaurant: "RESTAURANT",
        technicalSupport: "TECHNISCHER SUPPORT",
        guest: "KUNDE",
    },
    sidebar: {
        dashboard: "Dashboard",
        pos: "POS",
        posSystem: "POS-System",
        sales: "Verkäufe",
        orders: "Bestellungen",
        transactions: "Transaktionen",
        salesReport: "Verkaufsbericht",
        management: "Verwaltung",
        timeSlots: "Zeitslots",
        deliveryZones: "Lieferzonen",
        products: "Produkte",
        categories: "Kategorien",
        ingredients: "Zutaten",
        ingredientTypes: "Zutatentypen",
        managmentCategories: "Beheer van ingrediëntencategorieën",
        features: "Features",
        supplements: "Beilagen",
        supplementTypes: "Beilagentypen",
        ingredientBases: "Basiszutaten",
        campaigns: "Kampagnen",
        emailCampaigns: "E-Mail-Kampagnen",
        pushNotifications: "Push-Benachrichtigungen",
        programs: "Empfehlung & Treue",
        customers: "Kunden",
        users: "Benutzer",
        userList: "Benutzerliste",
        restaurants: "Restaurants",
        restaurantList: "Restaurantliste",
        franchises: "Franchise",
        accounts: "Konten",
        coupon: "Gutschein",
        openingHours: "Öffnungszeiten",
        paymentMethods: "Zahlungsmethoden",
        logout: "Abmelden",
        referral: "Programme",
        loyalty: "Treue & Parrainage",
        giftCards: "Geschenkkarten",
    },
    order: {
        orders: "Bestellungen",
        removed: "Entfernt",
        noOrders: "Keine Bestellungen gefunden.",
        orderDetails: "Bestelldetails",
        createDate: "Erstellt am:",
        pickupDate: "Abholtermin:",
        paymentMethod: "Zahlungsmethode:",
        orderType: "Bestelltyp:",
        notSpecified: "Nicht angegeben",
        immediately: "SOFORT",
        customer: "Kunde",
        customerInfo: "Kundeninformationen",
        deliveryAddress: "Lieferadresse",
        orderItems: "Bestellartikel",
        productList: "Produktliste",
        subtotal: "Zwischensumme",
        deliveryFee: "Liefergebühr",
        discount: "Rabatt",
        tax: "Steuer",
        grandTotal: "Gesamtsumme",
        orderStatus: "Bestellstatus",
        notes: "Notizen",
        invoice: "Rechnung & Empfehlung",
        invoiceNumber: "Rechnung:",
        coupon: "Gutschein:",
        civility: "Anrede:",
        customerType: "Kundentyp:",
        company: "Unternehmen",
        classic: "Klassisch",
        fullName: "Vollständiger Name:",
        email: "E-Mail:",
        phoneNumber: "Telefonnummer",
        quantity: "Menge",
        total: "Gesamt",
        ingredients: "Zutaten",
        supplements: "Beilagen",
        noSupplements: "Keine Beilagen",
        supplementName: "NAME DER BEILAGE",
        ingredientName: "ZUTATENNAME",
        type: "TYP",
        price: "PREIS",
        description: "BESCHREIBUNG",
        orderNote: "Bestellnotiz",
        orderId: "Bestell-ID-",
        estimatedDeliveryTime: "Geschätzte Lieferzeit",
        customerInstruction: "Kundenanweisung",
        orderSummary: "Bestellzusammenfassung",
        includingVat: "INKL. MwSt. (2,60%)",
        includingVatDynamic: "INKL. MwSt. ({rate}%)",
        additionalFees: "ZUSÄTZLICHE GEBÜHREN",
        noIngredients: "Keine Zutaten",
        unknownProduct: "Unbekanntes Produkt",
        noCategory: "Keine Kategorie",
        yes: "Ja",
        no: "Nein",
        free: "Kostenlos",
        paid: "Bezahlt",
        shouldSlice: "Sollen wir schneiden",
        paymentAddress: "Rechnungsadresse",
        street: "Straße",
        number: "Nr.",
        postalCode: "PLZ",
        locality: "Ortschaft",
        phone: "Telefon",
        totalGross: "BRUTTOTAL",
        vat: "2,60% MwSt.",
        productName: "PRODUKTNAME",
        productPrice: "PRODUKTPREIS",
        paymentStatus: "Zahlungsstatus",
        paymentMethodTitle: "Zahlungsmethode",
        paymentMethods: {
            payClickCollectCash: "Barzahlung",
            payClickCollectCarte: "Kartenzahlung",
            payDeliveryCash: "Barzahlung bei Lieferung",
            payDeliveryCarte: "Kartenzahlung bei Lieferung",
            online: "Online-Zahlung (Walle)",
        },
        orderTypes: {
            delivery: "Lieferung",
            clickCollect: "Abholung",
            dineIn: "Vor Ort",
        },
        status: {
            pending: "Ausstehend",
            processing: "In Bearbeitung",
            readyForDelivery: "Bereit zur Lieferung",
            outForDelivery: "Unterwegs zur Lieferung",
            delivered: "Geliefert",
            cancelled: "Storniert",
        },
        preOrder: "VORBESTELLUNG",
        rightAway: "SOFORT",
        products: "Produkte",
        netTotal: "Nettogesamt",
        viewDetails: "Details anzeigen",
        viewPdf: "PDF anzeigen",
        noOrdersAvailable: "Keine Bestellungen verfügbar.",
        unknown: "Unbekannt",
        transactionReference: "Transaktionsreferenz",
        pdf: "PDF",
    },
    product: {
        addProduct: "Produkt hinzufügen",
        editProduct: "Produkt bearbeiten",
        productName: "Produktname",
        productDescription: "Produktbeschreibung",
        productPrice: "Produktpreis",
        productCategory: "Produktkategorie",
        productImage: "Produktbild",
        nutritionalValues: "Hinweise & Nährwerte",
        multilingualTranslations: "Mehrsprachige Übersetzungen",
        complete: "Vollständig",
        incomplete: "Unvollständig",
        giveNote: "Geben Sie eine Notiz und Nährwert an",
        type: "Typ",
        category: "Kategorie",
        restaurant: "Restaurant",
        positioning: "Positionierung",
        image: "Bild",
        uploadFile: "Datei hochladen",
        httpsLink: "HTTPS-Link",
        acceptedFormats: "Akzeptierte Formate: JPEG, PNG, WebP (max 2 MB)",
        enterValidHttpsUrl: "Geben Sie eine gültige HTTPS-URL zu einem Bild ein",
        productVariation: "Produktvariation (verschiedene Größen angeben)",
        updateVariation: "Variation aktualisieren",
        addVariation: "Variation hinzufügen",
        sizes: "Größe(n)",
        noSize: "Keine Größe",
        specifyProductSizes: "Verschiedene Größen des Produkts angeben",
        size: "Größe",
        takeawayPrice: "Preis zum Mitnehmen",
        deliveryPriceLabel: "Lieferpreis",
        specificSizeDescription: "Spezifische Beschreibung für diese Größe",
        add: "Hinzufügen",
        validate: "Bestätigen",
        remove: "Entfernen",
        noSizeAdded: "Derzeit keine Größe hinzugefügt",
        SIZE: "GRÖSSE",
        TAKEAWAY_PRICE: "PREIS ZUM MITNEHMEN",
        DELIVERY_PRICE: "LIEFERPREIS",
        DESCRIPTION: "BESCHREIBUNG",
        ACTIONS: "AKTIONEN",
        addTurkeyBreast: "Putenbrust hinzufügen",
        addHam: "Schinken hinzufügen",
        addPowderedSugar: "Puderzucker hinzufügen",
        addSauces: "Saucen hinzufügen",
        addCheese: "Käse hinzufügen",
        removeAllOptions: "Alle Optionen entfernen",
        chooseAppropriateRestaurant: "Wählen Sie das entsprechende Restaurant",
        restaurantNotMatchCategory: "Das ausgewählte Restaurant entspricht nicht dem der Produktkategorie. Bitte wählen Sie das entsprechende Restaurant.",
        baseIngredients: "Basiszutaten",
        updateIngredients: "Zutaten aktualisieren",
        addBaseIngredients: "Basiszutaten hinzufügen",
        noIngredientSelected: "Keine Zutat ausgewählt",
        searchBaseIngredient: "Basiszutat suchen",
        selectedIngredients: "Ausgewählte Zutaten",
        noIngredientFound: "Keine Zutat gefunden für",
        selectPizzaBaseIngredients: "Basiszutaten der Pizza auswählen",
        baseSupplements: "Basis-Ergänzungen",
        updateSupplements: "Ergänzungen aktualisieren",
        addBaseSupplements: "Basis-Ergänzungen hinzufügen",
        noSupplementSelected: "Keine Ergänzung ausgewählt",
        searchSupplement: "Ergänzung suchen",
        selectedSupplements: "Ausgewählte Ergänzungen",
        noSupplementFound: "Keine Ergänzung gefunden für",
        selectBaseSupplements: "Basis-Ergänzungen auswählen",
        productNameInLanguage: "Produktname auf",
        descriptionInLanguage: "Beschreibung auf",
        notesInLanguage: "Notizen auf",
        update: "Aktualisieren",
        categoryResetWarning: "Die Kategorie wurde zurückgesetzt, da sie nicht zum ausgewählten Restaurant passt.",
        invalidUrlMessage: "Ungültige URL. Bitte geben Sie eine gültige URL ein (z.B. https://beispiel.com/bild.jpg)",
        categoryNotBelongRestaurant: "Diese Kategorie gehört nicht zum ausgewählten Restaurant. Bitte wählen Sie eine entsprechende Kategorie.",
    },
    category: {
        addCategory: "Kategorie hinzufügen",
        editCategory: "Kategorie bearbeiten",
        categoryName: "Kategoriename",
        categoryDescription: "Kategoriebeschreibung",
        categoryImage: "Kategoriebild",
        multilingualTranslations: "Mehrsprachige Übersetzungen",
        complete: "Vollständig",
        incomplete: "Unvollständig",
    },
    ingredient: {
        addIngredient: "Zutat hinzufügen",
        editIngredient: "Zutat bearbeiten",
        ingredientName: "Zutatenname",
        ingredientDescription: "Zutatenbeschreibung",
        ingredientPrice: "Zutatenpreis",
        ingredientImage: "Zutatenbild",
        ingredientPosition: "Position",
        ingredientPositionPlaceholder: "z.B. 1, 2, 3...",
        ingredientPositionHelp: "Position der Zutat in der Liste (optional)",
        multilingualTranslations: "Mehrsprachige Übersetzungen",
        complete: "Vollständig",
        incomplete: "Unvollständig",
        manageTypes: "Typen verwalten",
        manageTypePositions: "Zutatentyp-Positionen verwalten",
        noTypesAvailable: "Keine Zutatentypen verfügbar",
        noIngredientTypesAvailable: "Keine Zutatentypen verfügbar",
        addIngredientType: "Zutatentyp hinzufügen",
        editIngredientType: "Zutatentyp bearbeiten",
        code: "Code",
        label: "Bezeichnung",
        typeCreated: "Zutatentyp erfolgreich erstellt",
        typeUpdated: "Zutatentyp erfolgreich aktualisiert",
        typeDeleted: "Zutatentyp erfolgreich gelöscht",
        errorLoadingTypes: "Fehler beim Laden der Zutatentypen",
        errorSavingType: "Fehler beim Speichern des Zutatentyps",
        errorDeletingType: "Fehler beim Löschen des Zutatentyps",
        errorUpdatingPosition: "Fehler beim Aktualisieren der Position",
        deleteTypeConfirmation: "Löschbestätigung",
        deleteTypeConfirmationText: "Sind Sie sicher, dass Sie diesen Zutatentyp löschen möchten?<br />Diese Aktion ist irreversibel. Mit diesem Typ verbundene Zutaten haben ihren Typ auf NULL gesetzt.",
        codeHelp: "Der Code muss eindeutig sein (z.B. FISCH, KÄSE usw.)",
        positionHelp: "Anzeigeposition (optional, Minimum 1)",
        translations: "Übersetzungen",
        notDefined: "Nicht definiert",
        manageTranslations: "Übersetzungen verwalten",
        translationUpdated: "Übersetzung erfolgreich aktualisiert",
        errorUpdatingTranslation: "Fehler beim Aktualisieren der Übersetzung",
        noIngredients: "Momentan keine Zutaten",
        type: "Typ",
        position: "Position",
        deleteConfirmation: "Löschbestätigung",
        deleteConfirmationText: "Sind Sie sicher, dass Sie diese Zutat löschen möchten?<br />Diese Aktion ist unwiderruflich.",
        invalidPosition: "Bitte geben Sie eine gültige Position ein (Minimum 1)",
        positionUpdated: "Position erfolgreich aktualisiert",
        paginationInfo: "Anzeige von {start} bis {end} von {total} Ergebnissen",
        namePlaceholder: "z.B. Pfeffer",
        managePositions: "Positionen verwalten",
        selectType: "Wählen Sie einen Typ",
        typePlaceholder: "Zutatentyp auf {lang}",
        namePlaceholderLang: "Zutatenname auf {lang}",
        icon: "Symbol",
        imageUrlPlaceholder: "Bild-URL einfügen (z.B. https://...)",
        variationLabel: "Zutatenvariation (Verschiedene Größen angeben)",
        updateVariation: "Variation aktualisieren",
        addVariation: "Variation hinzufügen",
        size: "Größe",
        noSizeAdded: "Momentan keine Größe hinzugefügt",
        noSizeAddedModal: "Momentan keine Größe hinzugefügt",
        specifySizes: "Verschiedene Größen der Zutat angeben",
        sizePlaceholder: "Groß",
        pricePlaceholder: "12.90",
        remove: "Entfernen",
        addVariationRequired: "Fügen Sie mindestens eine Variation (Größe/Preis) für die Zutat hinzu",
    },
    supplement: {
        addSupplement: "Beilage hinzufügen",
        editSupplement: "Beilage bearbeiten",
        supplementName: "Name der Beilage",
        supplementDescription: "Beschreibung der Beilage",
        supplementPrice: "Preis der Beilage",
        supplementImage: "Bild der Beilage",
        supplementPosition: "Position",
        supplementPositionPlaceholder: "z.B. 1, 2, 3...",
        supplementPositionHelp: "Position der Beilage in der Liste (optional)",
        multilingualTranslations: "Mehrsprachige Übersetzungen",
        complete: "Vollständig",
        incomplete: "Unvollständig",
        manageTypes: "Typen verwalten",
        manageTypePositions: "Positionen der Beilagentypen verwalten",
        noTypesAvailable: "Kein Beilagentyp verfügbar",
        noSupplementTypesAvailable: "Kein Beilagentyp verfügbar",
        addSupplementType: "Beilagentyp hinzufügen",
        editSupplementType: "Beilagentyp bearbeiten",
        code: "Code",
        label: "Bezeichnung",
        typeCreated: "Beilagentyp erfolgreich erstellt",
        typeUpdated: "Beilagentyp erfolgreich aktualisiert",
        typeDeleted: "Beilagentyp erfolgreich gelöscht",
        errorLoadingTypes: "Fehler beim Laden der Beilagentypen",
        errorSavingType: "Fehler beim Speichern des Beilagentyps",
        errorDeletingType: "Fehler beim Löschen des Beilagentyps",
        errorUpdatingPosition: "Fehler beim Aktualisieren der Position",
        deleteTypeConfirmation: "Löschbestätigung",
        deleteTypeConfirmationText: "Sind Sie sicher, dass Sie diesen Beilagentyp löschen möchten?<br />Diese Aktion ist unwiderruflich. Beilagen, die mit diesem Typ verknüpft sind, werden ihren Typ auf NULL gesetzt bekommen.",
        codeHelp: "Der Code muss eindeutig sein (z.B. SAUCE, KÄSE usw.)",
        positionHelp: "Anzeigeposition (optional, mindestens 1)",
        translations: "Übersetzungen",
        notDefined: "Nicht definiert",
        manageTranslations: "Übersetzungen verwalten",
        translationUpdated: "Übersetzung erfolgreich aktualisiert",
        errorUpdatingTranslation: "Fehler beim Aktualisieren der Übersetzung",
        noSupplements: "Momentan keine Beilagen",
        type: "Typ",
        position: "Position",
        deleteConfirmation: "Löschbestätigung",
        deleteConfirmationText: "Sind Sie sicher, dass Sie diese Beilage löschen möchten?<br />Diese Aktion ist unwiderruflich.",
        invalidPosition: "Bitte geben Sie eine gültige Position ein (mindestens 1)",
        positionUpdated: "Position erfolgreich aktualisiert",
        paginationInfo: "Anzeige von {start} bis {end} von {total} Ergebnissen",
        namePlaceholder: "z.B. Scharfe Sauce",
        managePositions: "Positionen verwalten",
        selectType: "Wählen Sie einen Typ",
        typePlaceholder: "Beilagentyp in {lang}",
        namePlaceholderLang: "Name der Beilage in {lang}",
        icon: "Symbol",
        imageUrlPlaceholder: "Bild-URL der Beilage",
        variationLabel: "Preisvariationen",
        updateVariation: "Variationen aktualisieren",
        addVariation: "Variationen hinzufügen",
        size: "Größe",
        noSizeAdded: "Momentan keine Größe hinzugefügt",
        noSizeAddedModal: "Momentan keine Größe hinzugefügt",
        specifySizes: "Verschiedene Größen der Beilage angeben",
        sizePlaceholder: "Groß",
        pricePlaceholder: "2.50",
        remove: "Entfernen",
        addVariationRequired: "Fügen Sie mindestens eine Variation (Größe/Preis) für die Beilage hinzu",
    },
    feature: {
        addFeature: "Feature hinzufügen",
        editFeature: "Feature bearbeiten",
        featureName: "Feature-Name",
        featureDescription: "Feature-Beschreibung",
        featurePrice: "Feature-Preis",
        featureImage: "Feature-Bild",
        featurePosition: "Position",
        featurePositionPlaceholder: "z.B. 1, 2, 3...",
        featurePositionHelp: "Position des Features in der Liste (optional)",
        multilingualTranslations: "Mehrsprachige Übersetzungen",
        complete: "Vollständig",
        incomplete: "Unvollständig",
        translations: "Übersetzungen",
        notDefined: "Nicht definiert",
        manageTranslations: "Übersetzungen verwalten",
        translationUpdated: "Übersetzung erfolgreich aktualisiert",
        errorUpdatingTranslation: "Fehler beim Aktualisieren der Übersetzung",
        noFeatures: "Momentan keine Features",
        position: "Position",
        deleteConfirmation: "Löschbestätigung",
        deleteConfirmationText: "Sind Sie sicher, dass Sie dieses Feature löschen möchten?<br />Diese Aktion ist unwiderruflich.",
        invalidPosition: "Bitte geben Sie eine gültige Position ein (Minimum 1)",
        positionUpdated: "Position erfolgreich aktualisiert",
        paginationInfo: "Anzeige von {start} bis {end} von {total} Ergebnissen",
        namePlaceholder: "z.B. Neues Feature",
        managePositions: "Positionen verwalten",
        namePlaceholderLang: "Feature-Name auf {lang}",
        icon: "Symbol",
        imageUrlPlaceholder: "Feature-Bild-URL",
        variationLabel: "Preisvariationen",
        updateVariation: "Variationen aktualisieren",
        addVariation: "Variationen hinzufügen",
        size: "Größe",
        noSizeAdded: "Momentan keine Größe hinzugefügt",
        noSizeAddedModal: "Momentan keine Größe hinzugefügt",
        specifySizes: "Geben Sie die verschiedenen Größen des Features an",
        sizePlaceholder: "Groß",
        pricePlaceholder: "2.50",
        remove: "Entfernen",
        addVariationRequired: "Fügen Sie mindestens eine Variation (Größe/Preis) für das Feature hinzu",
        features: "Funktionen"
    },
    auth: {
        login: "Anmelden",
        loginButton: "Anmelden",
        register: "Registrieren",
        registerButton: "Registrieren",
        createAccount: "Erstellen Sie Ihr Konto",
        forgotPassword: "Passwort vergessen?",
        forgotPasswordText: "Geben Sie unten Ihre E-Mail-Adresse ein und wir senden Ihnen das wiederhergestellte Passwort zu",
        resetPassword: "Passwort zurücksetzen",
        email: "E-Mail",
        emailAddress: "E-Mail-Adresse",
        password: "Passwort",
        confirmPassword: "Passwort bestätigen",
        firstName: "Vorname",
        lastName: "Nachname",
        name: "Name",
        rememberMe: "Merken",
        backToSignIn: "Zurück zur Anmeldung",
        alreadyHaveAccount: "Haben Sie bereits ein Konto?",
        dontHaveAccount: "Haben Sie kein Konto?",
        logInNow: "Jetzt anmelden",
        registerNow: "Jetzt registrieren",
        acceptTerms: "Ich akzeptiere alle",
        termsAndConditions: "Geschäftsbedingungen",
        submit: "Absenden",
        invalidCredentials: "Ungültiger Benutzername oder Passwort",
        missingToken: "Authentifizierungstoken fehlt",
    },
    validation: {
        required: "Dieses Feld ist erforderlich",
        email: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
        minLength: "Dieses Feld muss mindestens {min} Zeichen enthalten",
        maxLength: "Dieses Feld darf nicht mehr als {max} Zeichen enthalten",
        passwordMismatch: "Die Passwörter stimmen nicht überein",
    },
    messages: {
        success: {
            saved: "Erfolgreich gespeichert",
            deleted: "Erfolgreich gelöscht",
            updated: "Erfolgreich aktualisiert",
            paymentMethodUpdated: "Zahlungsmethode erfolgreich aktualisiert",
            paymentMethodActivated: "Zahlungsmethode erfolgreich aktiviert",
            paymentMethodDeactivated: "Zahlungsmethode erfolgreich deaktiviert",
            paymentMethodAdded: "Zahlungsmethode erfolgreich hinzugefügt",
            userDeleted: "Benutzer erfolgreich gelöscht",
            userStatusUpdated: "Benutzerstatus erfolgreich aktualisiert",
            postalCodeAdded: "Postleitzahl erfolgreich hinzugefügt",
            postalCodeRemoved: "Postleitzahl {code} entfernt",
            variationsUpdated: "Variationen erfolgreich aktualisiert",
            imageSelected: "Bild erfolgreich ausgewählt",
            openingHoursDeleted: "Öffnungszeiten erfolgreich gelöscht",
            userAddedToCampaign: "Benutzer zur Kampagne hinzugefügt",
            couponRemoved: "Gutschein entfernt",
            newOrderReceived: "Neue Bestellung erhalten!",
            newOrderInRestaurant: "Neue Bestellung in einem Restaurant",
            ingredientAdded: "Zutat erfolgreich hinzugefügt",
            ingredientRemoved: "Zutat erfolgreich entfernt",
            baseIngredientsValidated: "Basis-Zutaten validiert",
            supplementAdded: "Ergänzung erfolgreich hinzugefügt",
            supplementRemoved: "Ergänzung erfolgreich entfernt",
            baseSupplementsValidated: "Basis-Ergänzungen validiert",
            printTicketSuccess: "🎉 Ticket erfolgreich gedruckt",
            timeSlotDeleted: "Zeitslot erfolgreich gelöscht",
            timeSlotActivated: "Zeitslot erfolgreich aktiviert",
            timeSlotDeactivated: "Zeitslot erfolgreich deaktiviert",
        },
        error: {
            generic: "Ein Fehler ist aufgetreten",
            loadFailed: "Fehler beim Laden",
            network: "Verbindungsfehler",
            unauthorized: "Nicht autorisiert",
            notFound: "Ressource nicht gefunden",
            invalidPaymentMethod: "Ungültige Zahlungsmethode",
            paymentMethodUpdateFailed: "Fehler beim Aktualisieren der Zahlungsmethode",
            loadPaymentMethodsFailed: "Fehler beim Laden der Zahlungsmethoden",
            updateFailed: "Fehler beim Aktualisieren",
            statusUpdateFailed: "Fehler beim Aktualisieren des Status",
            paymentStatusUpdateFailed: "Fehler beim Aktualisieren des Zahlungsstatus",
            deleteUserFailed: "Fehler beim Löschen des Benutzers",
            updateUserStatusFailed: "Fehler beim Aktualisieren des Benutzerstatus",
            loadUsersFailed: "Fehler beim Laden der Benutzer",
            restaurantIdNotFound: "Restaurant-ID nicht gefunden",
            loadDeliveryZoneFailed: "Fehler beim Laden der Lieferzone",
            loadCategoriesFailed: "Fehler beim Laden der Kategorien",
            loadRestaurantsFailed: "Fehler beim Laden der Restaurants",
            loadOrdersFailed: "Fehler beim Laden der Bestellungen",
            loadCampaignsFailed: "Fehler beim Laden der Kampagnen",
            loadProductsFailed: "Fehler beim Laden der Produkte",
            loadIngredientsFailed: "Fehler beim Laden der Zutaten",
            loadSupplementsFailed: "Fehler beim Laden der Beilagen",
            loadIngredientBasesFailed: "Fehler beim Laden der Basis-Zutaten",
            loadOpeningHoursFailed: "Fehler beim Laden der Öffnungszeiten",
            loadDeliveryZonesFailed: "Fehler beim Laden der Lieferzonen",
            loadTimeSlotsFailed: "Fehler beim Laden der Zeitslots",
            loadCouponsFailed: "Fehler beim Laden der Gutscheine",
            loadFranchisesFailed: "Fehler beim Laden der Franchises",
            loadOperationsFailed: "Fehler beim Laden der Operationen",
            loadDataFailed: "Fehler beim Laden der Daten",
            loadPostalCodesFailed: "Fehler beim Laden der Postleitzahlen",
            loadOrderTypesFailed: "Fehler beim Laden der Bestelltypen",
            loadCustomerInfoFailed: "Fehler beim Laden der Kundeninformationen",
            loadTimeSlotFailed: "Fehler beim Laden des Zeitfensters",
            saveFeatureFailed: "Fehler beim Speichern des Features",
            loadFeatureFailed: "Fehler beim Laden des Features",
            deleteFeatureFailed: "Fehler beim Löschen des Features",
            updateFeaturePositionFailed: "Fehler beim Aktualisieren der Feature-Position",
            fileTypeNotAllowed: "Dateityp nicht erlaubt",
            fileTooLarge: "Datei zu groß",
            invalidQuantity: "Ungültige Menge",
            restaurantInfoMissing: "Restaurantinformationen fehlen",
            fillAllFields: "Bitte füllen Sie alle Felder aus",
            couponAlreadyApplied: "Ein Gutschein wurde bereits angewendet",
            enterPromoCode: "Bitte geben Sie einen Promo-Code ein",
            invalidPromoCode: "Ungültiger Promo-Code",
            imageUploadFailed: "Fehler beim Hochladen des Bildes",
            selectValidImageFile: "Bitte wählen Sie eine gültige Bilddatei aus",
            fileSizeExceeded: "Die Dateigröße darf 5 MB nicht überschreiten",
            deletionFailed: "Fehler beim Löschen",
            invalidPrice: "Der Preis muss eine gültige Zahl sein",
            ingredientBaseNameRequired: "Der Name der Basis-Zutat ist erforderlich",
            deleteTimeSlotFailed: "Fehler beim Löschen des Zeitslots",
            deleteOrderFailed: "Fehler beim Löschen der Bestellung",
            deleteVariationFailed: "Fehler beim Löschen der Variation",
            deleteProductFailed: "Fehler beim Löschen des Produkts",
            deletePostalCodeFailed: "Fehler beim Löschen der Postleitzahl",
            deleteZoneFailed: "Fehler beim Löschen der Zone",
            updateStatusFailed: "Fehler beim Aktualisieren des Status",
            updateZoneFailed: "Fehler beim Aktualisieren der Zone",
            updateStelaStatusFailed: "Fehler beim Aktualisieren des Stela-Status",
            updateFeaturedStatusFailed: "Fehler beim Aktualisieren des Featured-Status",
            selectRestaurant: "Bitte wählen Sie ein Restaurant aus",
            saveTimeSlotFailed: "Fehler beim Speichern des Zeitslots",
            saveOpeningHoursFailed: "Fehler beim Speichern der Öffnungszeiten",
            generatePdfFailed: "Fehler beim Generieren des PDFs",
            printTicketFailed: "Fehler beim Drucken des Tickets",
            loadExistingIngredientsFailed: "Fehler beim Laden der vorhandenen Zutaten",
            fillRequiredFields: "Bitte füllen Sie alle erforderlichen Felder aus",
            restaurantNotSelected: "Restaurant nicht ausgewählt",
            provideImageOrUrl: "Bitte geben Sie ein Bild an (Datei oder URL)",
            urlMustStartWithHttps: "Die URL muss mit https:// beginnen",
            ingredientAlreadyAdded: "Diese Zutat wurde bereits hinzugefügt",
            supplementAlreadyAdded: "Diese Ergänzung wurde bereits hinzugefügt",
            loadExistingSupplementsFailed: "Fehler beim Laden der vorhandenen Ergänzungen",
            loadUserAddressesFailed: "Fehler beim Laden der Benutzeradressen",
            loadRestaurantInfoFailed: "Fehler beim Laden der Restaurantinformationen",
            loadRestaurantDetailsFailed: "Fehler beim Laden der Restaurantdetails",
            reloadDataFailed: "Fehler beim Neuladen der Daten",
            loadProductFailed: "Fehler beim Laden des Produkts",
            invalidProductId: "Ungültige Produkt-ID",
            missingCategoryId: "Fehlende Kategorie-ID",
            editFeatureToImplement: "Bearbeitungsfunktion muss implementiert werden",
        },
        warning: {
            userAlreadyInList: "Dieser Benutzer ist bereits in der Liste",
            selectUser: "Bitte wählen Sie einen Benutzer aus",
            couponAlreadyApplied: "Ein Gutschein wurde bereits angewendet",
        },
    },
    lists: {
        add: "Hinzufügen",
        search: "Suchen",
        searchProduct: "Produkt suchen",
        searchOrder: "Bestellung suchen",
        filterByCategory: "Nach Kategorie filtern",
        selectRestaurant: "Restaurant auswählen",
        restaurant: "Restaurant",
        id: "ID",
        name: "NAME",
        category: "KATEGORIE",
        status: "STATUS",
        notificationStatus: {
            draft: "Entwurf",
            sent: "Gesendet",
        },
        createdAt: "ERSTELLT AM",
        featured: "EMPFOHLEN",
        size: "GRÖSSE",
        ref: "REF",
        type: "TYP",
        client: "KUNDE",
        amount: "BETRAG",
        orderStatus: "BESTELLSTATUS",
        paymentStatus: "ZAHLUNGSSTATUS",
        phoneNumber: "TELEFONNUMMER",
        actions: "AKTIONEN",
        cancel: "Abbrechen",
        delete: "Löschen",
        confirmDelete: "Sind Sie sicher, dass Sie dieses Produkt löschen möchten?",
        confirmDeleteText: "Diese Aktion ist irreversibel.",
        takeaway: "Zum Mitnehmen",
        dineIn: "Vor Ort",
        delivery: "Lieferung",
        pending: "Ausstehend",
        confirmed: "Bestätigt",
        preparing: "In Vorbereitung",
        ready: "Bereit",
        delivered: "Geliefert",
        cancelled: "Storniert",
        processing: "In Bearbeitung",
        readyForDelivery: "Bereit zur Lieferung",
        delivering: "Unterwegs",
        awaitingPayment: "Zahlung ausstehend",
        paid: "Bezahlt",
        refunded: "Erstattet",
        paymentCancelled: "Storniert",
        icon: "SYMBOL",
        availability: "VERFÜGBARKEIT",
        extraPrice: "ZUSATZPREIS",
        searchCustomer: "Kunde suchen",
        searchUser: "Benutzer suchen",
        clearSearch: "Suche löschen",
        fullName: "VOLLSTÄNDIGER NAME",
        email: "E-MAIL",
        phone: "TELEFON",
        accountType: "KONTOTYP",
        verification: "VERIFIZIERUNG",
        addUser: "Benutzer hinzufügen",
        userDetails: "Benutzerdetails",
        editHeadRestaurant: "Verantwortlicher für das Restaurant ändern",
        addRestaurant: "Restaurant hinzufügen",
        uploadMenu: "Menü hochladen",
        selectPdfFile: "PDF-Datei auswählen",
        maxFileSize: "Maximale Dateigröße",
        acceptedFormat: "Akzeptiertes Format",
        selectedFile: "Ausgewählte Datei",
        uploading: "Wird hochgeladen...",
        upload: "Hochladen",
        addTimeSlot: "Zeitslot hinzufügen",
        addDeliveryZone: "Lieferzone hinzufügen",
        searchRestaurant: "Restaurant suchen",
        searchTimeSlot: "Zeitslot suchen",
        searchZone: "Zone suchen",
        restaurantName: "RESTAURANTNAME",
        managerName: "NAME DES VERANTWORTLICHEN",
        zoneAndAddress: "ZONE & ADRESSE",
        zoneName: "ZONENNAME",
        minimumAmount: "MINDESTBETRAG",
        deliveryFee: "LIEFERGEBÜHR",
        freeDeliveryThreshold: "GRATIS LIEFERUNG SCHWELLE",
        postalCodes: "POSTLEITZAHLEN",
        confirmDeleteTimeSlot: "Sind Sie sicher, dass Sie diesen Zeitslot löschen möchten?",
        confirmDeleteRestaurant: "Sind Sie sicher, dass Sie dieses Restaurant löschen möchten?",
        confirmDeleteDeliveryZone: "Sind Sie sicher, dass Sie diese Lieferzone löschen möchten?",
        addCampaign: "Kampagne hinzufügen",
        searchCampaign: "Kampagne suchen",
        confirmDeleteCampaign: "Sind Sie sicher, dass Sie diese Kampagne löschen möchten?",
        campaignId: "ID",
        campaignTitle: "TITEL",
        campaignMessage: "NACHRICHT",
        campaignStatus: "STATUS",
        campaignRecipients: "EMPFÄNGER",
        campaignCreatedAt: "ERSTELLT AM",
        recipient: "Empfänger",
        recipients: "Empfänger",
        selectedRecipients: "ausgewählte Empfänger",
        view: "Ansehen",
        send: "Senden",
        verified: "Verifiziert",
        unverified: "Nicht verifiziert",
        noUsers: "Keine Benutzer im Moment",
        confirmDeleteUser: "Löschbestätigung",
        confirmDeleteUserText: "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?",
        confirmDeleteUserAction: "Diese Aktion ist unwiderruflich.",
        noCampaigns: "Keine Kampagnen im Moment",
        displayResults: "Anzeige von {start} bis {end} von {total} Ergebnissen",
        pickupDelay: "Abholverzögerung",
        deliveryDelay: "Lieferverzögerung",
        noTimeSlots: "Keine Zeitslots im Moment",
        confirmDeleteTitle: "Löschbestätigung",
        campaignStatuses: {
            sent: "Gesendet",
            pending: "Ausstehend",
            draft: "Entwurf",
            scheduled: "Geplant",
        },
        campaignTypes: {
            individual: "Individuell",
            group: "Gruppe",
        },
        allRestaurants: "Alle Restaurants",
        addToCampaign: "Zur Kampagne hinzufügen",
        removeRecipient: "Diesen Empfänger entfernen",
        usersAddedAutomatically: "{count} Benutzer automatisch hinzugefügt",
        addCoupon: "Gutschein hinzufügen",
        searchCoupon: "Gutschein suchen",
        confirmDeleteCoupon: "Sind Sie sicher, dass Sie diesen Gutschein löschen möchten?",
        manageOpeningHours: "Verwalten Sie die Öffnungszeiten Ihres Restaurants",
        addOpeningHours: "Stunden hinzufügen",
        noOpeningHours: "Keine Stunden konfiguriert",
        startConfigureOpeningHours: "Beginnen Sie mit der Konfiguration der Öffnungszeiten Ihres Restaurants.",
        configureOpeningHours: "Stunden konfigurieren",
        managePaymentMethods: "Verwalten Sie die Zahlungsmethoden Ihres Restaurants",
        addPaymentMethod: "Zahlungsmethode hinzufügen",
        paymentMethod: "Zahlungsmethode",
        noPaymentMethods: "Keine Zahlungsmethoden konfiguriert",
        startConfigurePaymentMethods: "Beginnen Sie mit der Konfiguration der Zahlungsmethoden Ihres Restaurants.",
        configurePaymentMethods: "Zahlungsmethoden konfigurieren",
        enabled: "Aktiviert",
        disabled: "Deaktiviert",
        selectPaymentMethod: "Zahlungsmethode auswählen",
        enablePaymentMethod: "Zahlungsmethode aktivieren",
        selectRestaurantFirst: "Bitte wählen Sie zuerst ein Restaurant aus",
        day: "Tag",
        hours: "Stunden",
        break: "Pause",
        closed: "Geschlossen",
        searchTransaction: "Transaktion suchen",
        transactionId: "TRANSAKTIONS-ID",
        orderId: "BESTELL-ID",
        confirmDeleteTransaction: "Sind Sie sicher, dass Sie diese Transaktion löschen möchten?",
        addIngredientBase: "Basiszutat hinzufügen",
        searchIngredientBase: "Basiszutat suchen",
        addNotification: "Benachrichtigung hinzufügen",
        searchNotification: "Benachrichtigung suchen",
        confirmDeleteNotification: "Sind Sie sicher, dass Sie diese Benachrichtigung löschen möchten?",
        searchProgram: "Programm suchen",
        programName: "PROGRAMMNAME",
        rewardEarned: "ERHALTENE BELOHNUNG",
        confirmDeleteProgram: "Sind Sie sicher, dass Sie dieses Programm löschen möchten?",
        noPrograms: "Derzeit sind keine Programme verfügbar",
        referral: "EMPFEHLUNG",
        loyalty: "TREUE",
        addFranchise: "Franchise hinzufügen",
        searchFranchise: "Franchise suchen",
        confirmDeleteFranchise: "Sind Sie sicher, dass Sie diese Franchise löschen möchten?",
        title: "TITEL",
        message: "NACHRICHT",
        edit: "Bearbeiten",
        confirmDeleteFranchiseText: "Sind Sie sicher, dass Sie diese Franchise löschen möchten?",
        show: "Anzeigen",
        platform: "PLATTFORM",
        translations: "ÜBERSETZUNGEN",
    },
    reports: {
        ordersByStatus: {
            title: "Bestellungen nach Status",
            subtitle: "Nach Zeitraum und Status filtern und Anzahl sowie Betrag anzeigen.",
            columns: {
                status: "Status",
                count: "Anzahl",
                amount: "Betrag",
            },
            empty: "Keine Daten für diesen Zeitraum.",
        },
        averageBasket: {
            title: "Durchschnittlicher Warenkorb",
            subtitle: "Nach Zeitraum, Bestelltyp, Zahlungsmethode und Status filtern.",
            valueLabel: "Durchschnittlicher Warenkorb",
            columns: {
                count: "Anzahl",
                totalAmount: "Betrag",
                averageBasket: "Durchschnittlicher Warenkorb",
            },
            empty: "Keine Daten für diesen Zeitraum.",
        },
    },
    forms: {
        restaurantImage: "Banner Bild Restaurant",
        website: "Webseite",
        enablePosWalkthrough: "Interaktive POS-Anleitung aktivieren",
        posWalkthroughDescription: "Wenn diese Option aktiviert ist, wird dem Restaurantpersonal bei der ersten Verwendung des POS eine Anleitung angezeigt.",
        sendingType: "Versandart",
        notificationType: "Benachrichtigungstyp",
        targetChoice: "Zielauswahl",
        example: "z.B.",
        passwordPlaceholder: "**************",
        phoneNumber: "Telefonnummer",
        country: "Land",
        switzerland: "Schweiz",
        france: "Frankreich",
        germany: "Deutschland",
        italy: "Italien",
        unitedKingdom: "Vereinigtes Königreich",
        unitedStates: "Vereinigte Staaten",
        belgium: "Belgien",
        austria: "Österreich",
        selectRestaurantPlaceholder: "Restaurant auswählen",
        selectTypePlaceholder: "Typ auswählen",
        selectCategoryPlaceholder: "Kategorie auswählen",
        searchCategoryPlaceholder: "Nach Kategorie suchen",
        chooseFile: "Datei auswählen",
        imageUrlPlaceholder: "https://beispiel.com/bild.jpg",
        searchIngredientPlaceholder: "Tippen Sie, um nach einer Zutat zu suchen...",
        searchSupplementPlaceholder: "Geben Sie ein, um nach einer Beilage zu suchen...",
        searchFeaturePlaceholder: "Geben Sie ein, um nach einem Feature zu suchen...",
        sizePlaceholder: "Groß",
        sizeDescriptionPlaceholder: "Geben Sie eine Beschreibung für diese Größe an",
        categoryDescriptionPlaceholder: "Geben Sie eine Beschreibung für die Kategorie an",
        online: "Online",
        atDelivery: "Bei Lieferung",
        powderedSugar: "Puderzucker",
        addParmesan: "Parmesan hinzufügen",
        addSauces: "Soßen hinzufügen",
        customize: "Anpassen",
        ham: "Schinken",
        turkeyBreast: "Putenbrust",
        italianSauce: "Italienische Soße",
        postalCode: "Postleitzahl",
        selectPostalCode: "Postleitzahl auswählen",
        city: "Stadt",
        selectCity: "Stadt auswählen",
        street: "Straße",
        role: "Rolle",
        selectRole: "Rolle auswählen",
        technicalSupport: "TECHNISCHER SUPPORT",
        oldPassword: "Altes Passwort",
        newPassword: "Neues Passwort",
        restaurantName: "Restaurantname",
        managerFirstName: "Vorname Verantwortlicher",
        managerLastName: "Nachname Verantwortlicher",
        vatNumber: "Umsatzsteuer-ID",
        address: "Adresse",
        streetNumber: "Hausnummer",
        zoneName: "Zonenname",
        minimumAmount: "Mindestbetrag (CHF)",
        deliveryFee: "Liefergebühr (CHF)",
        deliveryFeePlaceholder: "z.B. 5.00 (leer lassen für kostenlos)",
        freeDeliveryThreshold: "Kostenlose Lieferung ab (CHF)",
        freeDeliveryThresholdPlaceholder: "z.B. 30.00 (leer lassen für keinen Schwellenwert)",
        description: "Beschreibung",
        zoneDescription: "Zonenbeschreibung",
        postalCodes: "Postleitzahlen",
        postalCodePlaceholder: "Postleitzahl",
        locality: "Ortschaft",
        add: "Hinzufügen",
        postalCodesAdded: "Postleitzahl(en) hinzugefügt",
        noPostalCodes: "Keine Postleitzahlen hinzugefügt. Sie können sie nach der Erstellung der Zone hinzufügen.",
        removePostalCode: "Diese Postleitzahl entfernen",
        postalCodeLocalityAlreadyAdded: "Diese Kombination aus Postleitzahl und Ortschaft wurde bereits hinzugefügt",
        fillAllFields: "Bitte füllen Sie alle Felder aus",
        createZone: "Zone erstellen",
        updateZone: "Aktualisieren",
        pickupDelay: "Abholverzögerung (Minuten)",
        pickupDelayPlaceholder: "z.B.: 20",
        pickupDelayHelp: "Wartezeit für Abholbestellungen",
        deliveryDelay: "Lieferverzögerung (Minuten)",
        deliveryDelayPlaceholder: "z.B.: 45",
        deliveryDelayHelp: "Wartezeit für Lieferbestellungen",
        slotInterval: "Slot-Intervall (Minuten)",
        slotIntervalPlaceholder: "z.B.: 15",
        slotIntervalHelp: "Intervall zwischen jedem verfügbaren Slot",
        maxCapacity: "Maximale Kapazität",
        maxCapacityPlaceholder: "z.B.: 1",
        maxCapacityHelp: "Maximale Anzahl von Bestellungen pro Slot",
        startTime: "Startzeit",
        startTimeHelp: "Startzeit der Slots",
        endTime: "Endzeit",
        endTimeHelp: "Endzeit der Slots",
        activateConfig: "Diese Konfiguration aktivieren",
        timeSlotExample: "Beispiel: Wenn ein Kunde um 12:00 für die Lieferung bestellt, wird die nächste verfügbare Vorbestellung um 12:45 (12:00 + 45 Minuten) sein.",
        editTimeSlot: "Zeitslot bearbeiten",
        addTimeSlot: "Zeitslot hinzufügen",
        configureDelays: "Verzögerungen für Abhol- und Lieferbestellungen konfigurieren",
        updateTimeSlot: "Aktualisieren",
        title: "Titel",
        titlePlaceholder: "z.B. Neu",
        campaignDescription: "Kampagnenbeschreibung",
        recipients: "Empfänger",
        selectRestaurant: "Restaurant auswählen",
        type: "Typ",
        typeLabel: "Typ",
        selectType: "Typ auswählen",
        selectClient: "Kunden auswählen",
        addToCampaign: "Zur Kampagne hinzufügen",
        clientsAdded: "Kunde(n) hinzugefügt",
        selectDateTime: "Datum und Uhrzeit auswählen",
        couponCode: "Gutscheincode",
        couponCodePlaceholder: "z.B. 5",
        value: "Wert",
        limit: "Limit",
        limitPlaceholder: "z.B. 10",
        noUserFound: "Kein Benutzer gefunden",
        franchiseName: "Franchisename",
        franchiseDescription: "Franchisebeschreibung",
        franchiseDescriptionPlaceholder: "Beschreiben Sie die Franchise und ihre Aktivitäten (Spezialität, Gründungsdatum, etc...)",
        image: "Bild",
        uploadImage: "Bild hochladen",
        imagePreview: "Bildvorschau",
        removeImage: "Bild entfernen",
        changeImage: "Bild ändern",
        selectImage: "Bild auswählen",
        imageSizeWarning: "Die Bildgröße darf 1 MB nicht überschreiten.",
        programName: "Programmname",
        programDescription: "Programmbeschreibung",
        programDescriptionPlaceholder: "Geben Sie eine Beschreibung für das Programm an",
        gain: "Gewinn",
        gainPlaceholder: "z.B. Pizza",
        openingHoursTitle: "Öffnungszeiten",
        manageOpeningHours: "Verwalten Sie die Öffnungszeiten Ihres Restaurants",
        descriptionForDay: "Beschreibung für {dayLabel}",
        addAddress: "Adresse hinzufügen",
        noAddressSaved: "Keine Adresse gespeichert.",
        page: "Seite",
        noOrders: "Keine Bestellungen.",
        show: "Anzeigen",
        transactionReference: "Transaktionsreferenz",
        pdf: "PDF",
        civility: "Anrede",
        lastName: "Nachname",
        firstName: "Vorname",
        email: "E-Mail",
        phone: "Telefon",
        dateOfBirth: "Geburtsdatum",
        companyName: "Firmenname",
        companyAddress: "Firmenadresse",
        companyVat: "Umsatzsteuer-ID der Firma",
        companyPhone: "Firmentelefon",
        companyEmail: "Firmen-E-Mail",
        customerInfo: "Kundeninformationen",
        useCustomerGenericInfo: "Kundeninformationen verwenden",
        quantityUtensils: "Besteckmenge",
        orderDate: "Datum",
        orderTime: "Uhrzeit",
        whenOrderDesired: "Wann möchten Sie Ihre Bestellung?",
        dateAndTimeDesired: "Gewünschtes Datum und Uhrzeit",
        immediately: "Sofort",
        whatToPayAttention: "Worauf sollten wir achten?",
        orderInstructions: "Bestellanweisungen",
        productName: "Produktname",
        quantity: "Menge",
        price: "Preis",
        totalAmount: "Gesamtbetrag",
        ingredient: "Zutat",
        addIngredient: "Zutat hinzufügen",
        noProductInCart: "Derzeit keine Produkte im Warenkorb",
        availableIn: "Verfügbar in",
        size: "Größe",
        choose: "Wählen",
        cart: "Warenkorb",
        generalInfo: "Allgemeine Informationen",
        chooseSize: "Größe wählen",
        selectAdditionalIngredients: "Zusätzliche Zutaten auswählen",
        selectIngredient: "Zutat auswählen",
        averageAmount: "Durchschnittsbetrag",
        product: "Produkt",
        startDate: "Start",
        endDate: "Ende",
        start: "Start",
        end: "Ende",
        category: "Kategorie",
        orderType: "Bestellart",
        selectOrderType: "Bestellart auswählen",
        salesThisWeek: "VERKÄUFE DIESE WOCHE",
        totalOrders: "Gesamtbestellungen",
        totalSales: "Gesamtverkäufe",
        totalCustomers: "Gesamtkunden",
        totalProducts: "Gesamtprodukte",
        totalCategories: "Gesamtkategorien",
        totalIngredients: "Gesamtzutaten",
        totalTimeSlots: "Gesamtzeitslots",
        totalDeliveryZones: "Gesamtlieferzonen",
        totalUsers: "Gesamtbenutzer",
        totalRestaurants: "Gesamtrestaurants",
        totalFranchises: "Gesamtfranchises",
        totalCoupons: "Gesamtgutscheine",
        totalCampaigns: "Gesamtkampagnen",
        totalNotifications: "Gesamtbenachrichtigungen",
        totalPrograms: "Gesamtprogramme",
        totalIngredientBases: "Gesamtbasiszutaten",
        totalOpeningHours: "Gesamtöffnungszeiten",
        totalTransactions: "Gesamttransaktionen",
        totalCustomersThisMonth: "Gesamtkunden diesen Monat",
        totalOrdersThisMonth: "Gesamtbestellungen diesen Monat",
        totalSalesThisMonth: "Gesamtverkäufe diesen Monat",
        totalProductsThisMonth: "Gesamtprodukte diesen Monat",
        totalCategoriesThisMonth: "Gesamtkategorien diesen Monat",
        totalIngredientsThisMonth: "Gesamtzutaten diesen Monat",
        totalTimeSlotsThisMonth: "Gesamtzeitslots diesen Monat",
        totalDeliveryZonesThisMonth: "Gesamtlieferzonen diesen Monat",
        totalUsersThisMonth: "Gesamtbenutzer diesen Monat",
        totalRestaurantsThisMonth: "Gesamtrestaurants diesen Monat",
        totalFranchisesThisMonth: "Gesamtfranchises diesen Monat",
        totalCouponsThisMonth: "Gesamtgutscheine diesen Monat",
        totalCampaignsThisMonth: "Gesamtkampagnen diesen Monat",
        totalNotificationsThisMonth: "Gesamtbenachrichtigungen diesen Monat",
        totalProgramsThisMonth: "Gesamtprogramme diesen Monat",
        totalIngredientBasesThisMonth: "Gesamtbasiszutaten diesen Monat",
        totalOpeningHoursThisMonth: "Gesamtöffnungszeiten diesen Monat",
        totalTransactionsThisMonth: "Gesamttransaktionen diesen Monat",
        totalCustomersLastMonth: "Gesamtkunden letzten Monat",
        totalOrdersLastMonth: "Gesamtbestellungen letzten Monat",
        totalSalesLastMonth: "Gesamtverkäufe letzten Monat",
        totalProductsLastMonth: "Gesamtprodukte letzten Monat",
        totalCategoriesLastMonth: "Gesamtkategorien letzten Monat",
        totalIngredientsLastMonth: "Gesamtzutaten letzten Monat",
        totalTimeSlotsLastMonth: "Gesamtzeitslots letzten Monat",
        totalDeliveryZonesLastMonth: "Gesamtlieferzonen letzten Monat",
        totalUsersLastMonth: "Gesamtbenutzer letzten Monat",
        totalRestaurantsLastMonth: "Gesamtrestaurants letzten Monat",
        totalFranchisesLastMonth: "Gesamtfranchises letzten Monat",
        totalCouponsLastMonth: "Gesamtgutscheine letzten Monat",
        totalCampaignsLastMonth: "Gesamtkampagnen letzten Monat",
        totalNotificationsLastMonth: "Gesamtbenachrichtigungen letzten Monat",
        totalProgramsLastMonth: "Gesamtprogramme letzten Monat",
        totalIngredientBasesLastMonth: "Gesamtbasiszutaten letzten Monat",
        totalOpeningHoursLastMonth: "Gesamtöffnungszeiten letzten Monat",
        totalTransactionsLastMonth: "Gesamttransaktionen letzten Monat",
        totalCustomersLastYear: "Gesamtkunden letztes Jahr",
        totalOrdersLastYear: "Gesamtbestellungen letztes Jahr",
        totalSalesLastYear: "Gesamtverkäufe letztes Jahr",
        totalProductsLastYear: "Gesamtprodukte letztes Jahr",
        totalCategoriesLastYear: "Gesamtkategorien letztes Jahr",
        totalIngredientsLastYear: "Gesamtzutaten letztes Jahr",
        totalTimeSlotsLastYear: "Gesamtzeitslots letztes Jahr",
        totalDeliveryZonesLastYear: "Gesamtlieferzonen letztes Jahr",
        totalUsersLastYear: "Gesamtbenutzer letztes Jahr",
        totalRestaurantsLastYear: "Gesamtrestaurants letztes Jahr",
        totalFranchisesLastYear: "Gesamtfranchises letztes Jahr",
        totalCouponsLastYear: "Gesamtgutscheine letztes Jahr",
        totalCampaignsLastYear: "Gesamtkampagnen letztes Jahr",
        totalNotificationsLastYear: "Gesamtbenachrichtigungen letztes Jahr",
        totalProgramsLastYear: "Gesamtprogramme letztes Jahr",
        totalIngredientBasesLastYear: "Gesamtbasiszutaten letztes Jahr",
        totalOpeningHoursLastYear: "Gesamtöffnungszeiten letztes Jahr",
        totalTransactionsLastYear: "Gesamttransaktionen letztes Jahr",
        totalCustomersAllTime: "Gesamtkunden aller Zeiten",
        totalOrdersAllTime: "Gesamtbestellungen aller Zeiten",
        totalSalesAllTime: "Gesamtverkäufe aller Zeiten",
        totalProductsAllTime: "Gesamtprodukte aller Zeiten",
        totalCategoriesAllTime: "Gesamtkategorien aller Zeiten",
        totalIngredientsAllTime: "Gesamtzutaten aller Zeiten",
        totalTimeSlotsAllTime: "Gesamtzeitslots aller Zeiten",
        totalDeliveryZonesAllTime: "Gesamtlieferzonen aller Zeiten",
        totalUsersAllTime: "Gesamtbenutzer aller Zeiten",
        totalRestaurantsAllTime: "Gesamtrestaurants aller Zeiten",
        totalFranchisesAllTime: "Gesamtfranchises aller Zeiten",
        totalCouponsAllTime: "Gesamtgutscheine aller Zeiten",
        totalCampaignsAllTime: "Gesamtkampagnen aller Zeiten",
        totalNotificationsAllTime: "Gesamtbenachrichtigungen aller Zeiten",
        totalProgramsAllTime: "Gesamtprogramme aller Zeiten",
        totalIngredientBasesAllTime: "Gesamtbasiszutaten aller Zeiten",
        totalOpeningHoursAllTime: "Gesamtöffnungszeiten aller Zeiten",
        totalTransactionsAllTime: "Gesamttransaktionen aller Zeiten",
        totalCustomersToday: "Gesamtkunden heute",
        totalOrdersToday: "Gesamtbestellungen heute",
        totalSalesToday: "Gesamtverkäufe heute",
        totalProductsToday: "Gesamtprodukte heute",
        totalCategoriesToday: "Gesamtkategorien heute",
        totalIngredientsToday: "Gesamtzutaten heute",
        totalTimeSlotsToday: "Gesamtzeitslots heute",
        totalDeliveryZonesToday: "Gesamtlieferzonen heute",
        totalUsersToday: "Gesamtbenutzer heute",
        totalRestaurantsToday: "Gesamtrestaurants heute",
        totalFranchisesToday: "Gesamtfranchises heute",
        totalCouponsToday: "Gesamtgutscheine heute",
        totalCampaignsToday: "Gesamtkampagnen heute",
        totalNotificationsToday: "Gesamtbenachrichtigungen heute",
        totalProgramsToday: "Gesamtprogramme heute",
        totalIngredientBasesToday: "Gesamtbasiszutaten heute",
        totalOpeningHoursToday: "Gesamtöffnungszeiten heute",
        totalTransactionsToday: "Gesamttransaktionen heute",
        totalCustomersYesterday: "Gesamtkunden gestern",
        totalOrdersYesterday: "Gesamtbestellungen gestern",
        totalSalesYesterday: "Gesamtverkäufe gestern",
        totalProductsYesterday: "Gesamtprodukte gestern",
        totalCategoriesYesterday: "Gesamtkategorien gestern",
        totalIngredientsYesterday: "Gesamtzutaten gestern",
        totalTimeSlotsYesterday: "Gesamtzeitslots gestern",
        totalDeliveryZonesYesterday: "Gesamtlieferzonen gestern",
        totalUsersYesterday: "Gesamtbenutzer gestern",
        totalRestaurantsYesterday: "Gesamtrestaurants gestern",
        totalFranchisesYesterday: "Gesamtfranchises gestern",
        totalCouponsYesterday: "Gesamtgutscheine gestern",
        totalCampaignsYesterday: "Gesamtkampagnen gestern",
        totalNotificationsYesterday: "Gesamtbenachrichtigungen gestern",
        totalProgramsYesterday: "Gesamtprogramme gestern",
        totalIngredientBasesYesterday: "Gesamtbasiszutaten gestern",
        totalOpeningHoursYesterday: "Gesamtöffnungszeiten gestern",
        totalTransactionsYesterday: "Gesamttransaktionen gestern",
        totalCustomersLast7Days: "Gesamtkunden letzte 7 Tage",
        totalOrdersLast7Days: "Gesamtbestellungen letzte 7 Tage",
        totalSalesLast7Days: "Gesamtverkäufe letzte 7 Tage",
        totalProductsLast7Days: "Gesamtprodukte letzte 7 Tage",
        totalCategoriesLast7Days: "Gesamtkategorien letzte 7 Tage",
        totalIngredientsLast7Days: "Gesamtzutaten letzte 7 Tage",
        totalTimeSlotsLast7Days: "Gesamtzeitslots letzte 7 Tage",
        totalDeliveryZonesLast7Days: "Gesamtlieferzonen letzte 7 Tage",
        totalUsersLast7Days: "Gesamtbenutzer letzte 7 Tage",
        totalRestaurantsLast7Days: "Gesamtrestaurants letzte 7 Tage",
        totalFranchisesLast7Days: "Gesamtfranchises letzte 7 Tage",
        totalCouponsLast7Days: "Gesamtgutscheine letzte 7 Tage",
        totalCampaignsLast7Days: "Gesamtkampagnen letzte 7 Tage",
        totalNotificationsLast7Days: "Gesamtbenachrichtigungen letzte 7 Tage",
        totalProgramsLast7Days: "Gesamtprogramme letzte 7 Tage",
        totalIngredientBasesLast7Days: "Gesamtbasiszutaten letzte 7 Tage",
        totalOpeningHoursLast7Days: "Gesamtöffnungszeiten letzte 7 Tage",
        totalTransactionsLast7Days: "Gesamttransaktionen letzte 7 Tage",
        totalCustomersLast30Days: "Gesamtkunden letzte 30 Tage",
        totalOrdersLast30Days: "Gesamtbestellungen letzte 30 Tage",
        totalSalesLast30Days: "Gesamtverkäufe letzte 30 Tage",
        totalProductsLast30Days: "Gesamtprodukte letzte 30 Tage",
        totalCategoriesLast30Days: "Gesamtkategorien letzte 30 Tage",
        totalIngredientsLast30Days: "Gesamtzutaten letzte 30 Tage",
        totalTimeSlotsLast30Days: "Gesamtzeitslots letzte 30 Tage",
        totalDeliveryZonesLast30Days: "Gesamtlieferzonen letzte 30 Tage",
        totalUsersLast30Days: "Gesamtbenutzer letzte 30 Tage",
        totalRestaurantsLast30Days: "Gesamtrestaurants letzte 30 Tage",
        totalFranchisesLast30Days: "Gesamtfranchises letzte 30 Tage",
        totalCouponsLast30Days: "Gesamtgutscheine letzte 30 Tage",
        totalCampaignsLast30Days: "Gesamtkampagnen letzte 30 Tage",
        totalNotificationsLast30Days: "Gesamtbenachrichtigungen letzte 30 Tage",
        totalProgramsLast30Days: "Gesamtprogramme letzte 30 Tage",
        totalIngredientBasesLast30Days: "Gesamtbasiszutaten letzte 30 Tage",
        totalOpeningHoursLast30Days: "Gesamtöffnungszeiten letzte 30 Tage",
        totalTransactionsLast30Days: "Gesamttransaktionen letzte 30 Tage",
        totalCustomersLast90Days: "Gesamtkunden letzte 90 Tage",
        totalOrdersLast90Days: "Gesamtbestellungen letzte 90 Tage",
        totalSalesLast90Days: "Gesamtverkäufe letzte 90 Tage",
        totalProductsLast90Days: "Gesamtprodukte letzte 90 Tage",
        totalCategoriesLast90Days: "Gesamtkategorien letzte 90 Tage",
        totalIngredientsLast90Days: "Gesamtzutaten letzte 90 Tage",
        totalTimeSlotsLast90Days: "Gesamtzeitslots letzte 90 Tage",
        totalDeliveryZonesLast90Days: "Gesamtlieferzonen letzte 90 Tage",
        totalUsersLast90Days: "Gesamtbenutzer letzte 90 Tage",
        totalRestaurantsLast90Days: "Gesamtrestaurants letzte 90 Tage",
        totalFranchisesLast90Days: "Gesamtfranchises letzte 90 Tage",
        totalCouponsLast90Days: "Gesamtgutscheine letzte 90 Tage",
        totalCampaignsLast90Days: "Gesamtkampagnen letzte 90 Tage",
        totalNotificationsLast90Days: "Gesamtbenachrichtigungen letzte 90 Tage",
        totalProgramsLast90Days: "Gesamtprogramme letzte 90 Tage",
        totalIngredientBasesLast90Days: "Gesamtbasiszutaten letzte 90 Tage",
        totalOpeningHoursLast90Days: "Gesamtöffnungszeiten letzte 90 Tage",
        totalTransactionsLast90Days: "Gesamttransaktionen letzte 90 Tage",
        totalCustomersLast365Days: "Gesamtkunden letzte 365 Tage",
        totalOrdersLast365Days: "Gesamtbestellungen letzte 365 Tage",
        totalSalesLast365Days: "Gesamtverkäufe letzte 365 Tage",
        totalProductsLast365Days: "Gesamtprodukte letzte 365 Tage",
        totalCategoriesLast365Days: "Gesamtkategorien letzte 365 Tage",
        totalIngredientsLast365Days: "Gesamtzutaten letzte 365 Tage",
        totalTimeSlotsLast365Days: "Gesamtzeitslots letzte 365 Tage",
        totalDeliveryZonesLast365Days: "Gesamtlieferzonen letzte 365 Tage",
        totalUsersLast365Days: "Gesamtbenutzer letzte 365 Tage",
        totalRestaurantsLast365Days: "Gesamtrestaurants letzte 365 Tage",
        totalFranchisesLast365Days: "Gesamtfranchises letzte 365 Tage",
        totalCouponsLast365Days: "Gesamtgutscheine letzte 365 Tage",
        totalCampaignsLast365Days: "Gesamtkampagnen letzte 365 Tage",
        totalNotificationsLast365Days: "Gesamtbenachrichtigungen letzte 365 Tage",
        totalProgramsLast365Days: "Gesamtprogramme letzte 365 Tage",
        totalIngredientBasesLast365Days: "Gesamtbasiszutaten letzte 365 Tage",
        totalOpeningHoursLast365Days: "Gesamtöffnungszeiten letzte 365 Tage",
        totalTransactionsLast365Days: "Gesamttransaktionen letzte 365 Tage",
        totalCustomersLastWeek: "Gesamtkunden letzte Woche",
        totalOrdersLastWeek: "Gesamtbestellungen letzte Woche",
        totalSalesLastWeek: "Gesamtverkäufe letzte Woche",
        totalProductsLastWeek: "Gesamtprodukte letzte Woche",
        totalCategoriesLastWeek: "Gesamtkategorien letzte Woche",
        totalIngredientsLastWeek: "Gesamtzutaten letzte Woche",
        totalTimeSlotsLastWeek: "Gesamtzeitslots letzte Woche",
        totalDeliveryZonesLastWeek: "Gesamtlieferzonen letzte Woche",
        totalUsersLastWeek: "Gesamtbenutzer letzte Woche",
        totalRestaurantsLastWeek: "Gesamtrestaurants letzte Woche",
        totalFranchisesLastWeek: "Gesamtfranchises letzte Woche",
        totalCouponsLastWeek: "Gesamtgutscheine letzte Woche",
        totalCampaignsLastWeek: "Gesamtkampagnen letzte Woche",
        totalNotificationsLastWeek: "Gesamtbenachrichtigungen letzte Woche",
        totalProgramsLastWeek: "Gesamtprogramme letzte Woche",
        totalIngredientBasesLastWeek: "Gesamtbasiszutaten letzte Woche",
        totalOpeningHoursLastWeek: "Gesamtöffnungszeiten letzte Woche",
        totalTransactionsLastWeek: "Gesamttransaktionen letzte Woche",
        filterByRestaurant: "Nach Restaurant filtern",
        amountOrdersByCategory: "BESTELLBETRAG NACH (KATEGORIE)",
        amountOrdersByProduct: "BESTELLBETRAG NACH (PRODUKT)",
        allTypes: "Alle Typen",
        allMethods: "Alle Methoden",
        orders: "Bestellung(en)",
        Orders: "Bestellung(en)",
        averageQuantityPerOrder: "DURCHSCHNITTLICHE MENGE EINES PRODUKTS PRO BESTELLUNG",
        errorLoadingCategories: "Fehler beim Laden der Kategorien",
        errorLoadingProducts: "Fehler beim Laden der Produkte",
        errorLoadingData: "Fehler beim Laden der Daten",
        errorLoadingRestaurant: "Fehler beim Laden der Restaurants",
        errorLoadingAverage: "Fehler beim Abrufen des Durchschnitts",
        errorLoadingAverageRate: "Fehler beim Laden der Durchschnittsrate",
        pleaseSelectRestaurant: "Bitte wählen Sie ein bestimmtes Restaurant aus, um Daten anzuzeigen.",
        pleaseSelectRestaurantRefresh: "Bitte wählen Sie ein Restaurant aus, um Daten zu aktualisieren.",
        noProductDataForPeriod: "Keine Produktdaten für diesen Zeitraum",
        noCategoryDataForPeriod: "Keine Kategoriedaten für diesen Zeitraum",
        allowOrderModification: "Bearbeitung von Bestellungen zulassen",
        allowOrderDeletion: "Löschung von Bestellungen zulassen",
        allowOrderAcceptation: "Annahme von Bestellungen zulassen",
        showGoogleMapsQr: "Google Maps QR Code auf Tickets anzeigen",
        showGoogleMapsQrHelp: "Gibt an, ob der Google Maps QR Code auf den Tickets angezeigt werden soll",
    },
    ingredientBase: {
        addIngredientBase: "Basiszutat hinzufügen",
        editIngredientBase: "Basiszutat bearbeiten",
        ingredientBaseName: "Basiszutatenname",
        ingredientBaseNameHelp: "Geben Sie den Namen der Basiszutat für Pizzen ein",
        ingredientBasePosition: "Position",
        ingredientBasePositionPlaceholder: "z.B. 1, 2, 3...",
        ingredientBasePositionHelp: "Position der Basiszutat in der Liste (optional)",
    },
    pos: {
        searchMenuPlaceholder: "Im Menü suchen...",
        noCategoriesFound: "Keine Kategorien gefunden",
        errorLoadingCategories: "Fehler beim Laden der Kategorien",
        noActiveProductsFound: "Keine aktiven Produkte für diese Kategorie gefunden",
        errorLoadingProducts: "Fehler beim Laden der Produkte",
        ingredientsLoadedSuccess: "Zutaten erfolgreich geladen",
        errorLoadingIngredients: "Fehler beim Laden der Zutaten",
        additionalOptions: "Zusätzliche Optionen",
        selectOneOption: "Bitte wählen Sie eine Option",
        customizeProduct: "Produkt anpassen",
        includedIngredientsInfo: "Mit \"Inklusive\" markierte Zutaten gehören zur Pizza",
        addModeDescription: "Hinzufügen-Modus: zusätzliche Zutaten hinzufügen",
        removeModeDescription: "Entfernen-Modus: auch inklusive Zutaten entfernen",
        included: "Inklusive",
        free: "Kostenlos",
        unknownIngredient: "Unbekannte Zutat",
        addToCart: "In den Warenkorb",
        add: "Hinzufügen",
        customize: "Anpassen",
        customizeIngredients: "Zutaten anpassen",
        remove: "Entfernen",
        addSpecialInstructions: "Fügen Sie spezielle Anweisungen für Ihre Bestellung hinzu...",
        customizeSalad: "Salat anpassen",
        customizePasta: "Nudeln anpassen",
        customizeOptions: "Optionen anpassen",
        customizeYour: "Personalisieren Sie Ihre",
        chooseOption: "Wählen Sie eine Option",
        selectedOption: "Ausgewählte Option",
        addParmesanDescription: "Fügen Sie geriebenen Parmesan für noch mehr Geschmack hinzu (1.00 CHF):",
        createCustomPizza: "Erstellen Sie Ihre personalisierte Pizza",
        searchIngredient: "Zutat suchen...",
        pizzaSummary: "Zusammenfassung Ihrer Pizza",
        sizeLabel: "Größe",
        noIngredientsSelected: "Keine Zutaten ausgewählt",
        chooseSize: "Größe wählen",
        glutenFree: "Glutenfrei",
        deliveryPrice: "Lieferpreis",
        noProductsFound: "Keine Produkte gefunden",
        tryChangeSearchOrCategory: "Versuchen Sie, Ihre Suche oder die ausgewählte Kategorie zu ändern.",
        addSaucesForSalad: "Fügen Sie Soßen hinzu, um Ihren Salat zu verfeinern.",
        chooseYourSauces: "Wählen Sie Ihre Soßen",
        cart: "Warenkorb",
        generalInfo: "Allgemeine Informationen",
        noProductInCart: "Derzeit keine Produkte im Warenkorb",
        availableIn: "Verfügbar in",
        size: "Größe",
        choose: "Wählen",
        orderInstructions: "Bestellanweisungen",
        selectOrderType: "Bestellart auswählen",
        whenOrder: "Wann möchten Sie Ihre Bestellung?",
        whatToPayAttention: "Worauf sollten wir achten?",
        orderNotes: "Bestellnotizen",
        requestUtensils: "Besteck anfordern",
        utensilsQuantity: "Besteckmenge",
        useCustomerInfo: "Kundeninformationen verwenden",
        cookingType: {
            normal: "Normal",
            rare: "Blutig",
            medium: "Medium",
            wellDone: "Gut durchgebraten",
        },
        schedule: {
            morningOpening: "Morgendliche Öffnung",
            lunchBreak: "Mittagspause",
            afternoonOpening: "Nachmittagsöffnung",
        },
        customerInfo: "Kundeninformationen",
        registeredCustomerSelected: "Registrierter Kunde ausgewählt",
        deselect: "Abwählen",
        firstName: "Vorname",
        firstNamePlaceholder: "Vorname des Kunden",
        lastName: "Nachname",
        lastNamePlaceholder: "Nachname des Kunden",
        phone: "Telefon",
        phonePlaceholder: "Telefonnummer",
        email: "E-Mail",
        emailPlaceholder: "E-Mail des Kunden",
        invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
        orderType: "Bestelltyp",
        orderTypeDineIn: "Vor Ort",
        orderTypeClickCollect: "Zum Mitnehmen",
        orderTypeDelivery: "Lieferung",
        clientType: "Kundentyp",
        clientTypeCustomer: "Kunde",
        clientTypeOrganisation: "Organisation",
        company: "Firma",
        companyPlaceholder: "Firmenname",
        department: "Abteilung",
        departmentPlaceholder: "Abteilung",
        pickupTime: "Abholzeit",
        pickupTimeHour: "Abholzeit",
        asSoonAsPossible: "So schnell wie möglich",
        restaurantClosed: "(Restaurant geschlossen)",
        readyInMinutes: "Bereit in 15-20 Minuten",
        scheduledDateTime: "Gewünschtes Datum und Uhrzeit",
        scheduleForLater: "Für später planen",
        pickupDate: "Abholdatum",
        selectDate: "Datum auswählen",
        selectTime: "Uhrzeit auswählen",
        noTimeAvailableToday: "Heute keine Zeit verfügbar. Bitte wählen Sie morgen.",
        deliveryAddress: "Lieferadresse",
        savedAddresses: "Gespeicherte Adressen",
        newAddress: "Neue Adresse",
        postalCode: "Postleitzahl (PLZ)",
        postalCodePlaceholder: "Postleitzahl",
        locality: "Ort",
        localityPlaceholder: "Ort",
        street: "Straße",
        streetPlaceholder: "Straßenname",
        streetNumber: "Hausnummer",
        streetNumberPlaceholder: "Hausnummer",
        order: "Bestellung",
        items: "Artikel",
        emptyCart: "Warenkorb leer",
        addItemsToStart: "Fügen Sie Artikel hinzu, um zu beginnen",
        summary: "Zusammenfassung",
        promoCode: "Gutscheincode",
        enterPromoCode: "Geben Sie Ihren Gutscheincode ein",
        apply: "Anwenden",
        couponRemoved: "Gutschein entfernt",
        minimumOrderAmount: "Mindestbestellwert:",
        supplementApplied: "(Zuschlag von {amount} CHF angewendet)",
        disableMinOrder: "Mindestbetrag deaktivieren",
        enableMinOrder: "Mindestbetrag wieder aktivieren",
        discountType: "Rabatttyp",
        percentage: "Prozentsatz (%)",
        fixedAmount: "Fester Betrag (CHF)",
        discount: "Rabatt",
        discountPercentage: "Rabatt (%)",
        discountFixed: "Rabatt (CHF)",
        miscellaneous: "Verschiedenes (CHF)",
        miscellaneousLabel: "Verschiedenes",
        slice: "Schneiden:",
        yes: "Ja",
        no: "Nein",
        note: "Hinweis",
        notePlaceholder: "Geben Sie Ihren Hinweis ein",
        subtotal: "Zwischensumme",
        discountLabel: "Rabatt",
        coupon: "Gutschein",
        customized: "Angepasst:",
        removed: "Entfernt:",
        options: "Optionen:",
        supplements: "Zusätze:",
        paymentMethod: "Zahlungsmethode",
        cashPayment: "Barzahlung",
        cardPayment: "Kartenzahlung",
        minOrderSupplement: "Mindestbestellzuschlag",
        vat: "MwSt ({rate}%)",
        total: "Gesamt",
        validateOrder: "Bestellung bestätigen",
        processing: "Verarbeitung...",
        orderCreatedSuccess: "Bestellung erfolgreich erstellt!",
        fillAllFields: "Bitte füllen Sie alle Felder aus!",
        restaurantInfoMissing: "Restaurantinformationen fehlen",
        invalidPromoCode: "Ungültiger Gutscheincode",
        orderCreationError: "Fehler beim Erstellen der Bestellung",
        today: "Heute",
        tomorrow: "Morgen",
    },
    dashboard: {
        greeting: "Hallo",
        whatHappeningToday: "Hier ist, was heute in Ihren Restaurants passiert",
        whatHappeningTodaySingle: "Hier ist, was heute in Ihrem Restaurant passiert",
        salesThisWeek: "VERKÄUFE DIESE WOCHE",
        salesThisWeekByRestaurant: "Verkäufe der aktuellen Woche nach Restaurant",
        salesThisWeekLabel: "Verkäufe diese Woche",
        vsPreviousWeek: "vs Vorwoche:",
        previousWeek: "Vorwoche",
        thisWeek: "Diese Woche",
        thisMonth: "Dieser Monat",
        thisYear: "Dieses Jahr",
        select: "Auswählen",
        noDataAvailable: "Keine Daten für das Diagramm verfügbar",
        salesReportThisWeek: "VERKAUFSBERICHT DIESE WOCHE",
        salesReportThisMonth: "VERKAUFSBERICHT DIESEN MONAT",
        salesReportThisYear: "VERKAUFSBERICHT DIESES JAHR",
        salesReportAllPeriods: "VERKAUFSBERICHT ALLE ZEITRÄUME",
        salesReportPreviousWeek: "VERKAUFSBERICHT VORWOCHE",
    },
    pages: {
        editCustomer: "Kunde bearbeiten",
        addFranchise: "Franchise hinzufügen",
        updateFranchise: "Franchise aktualisieren",
        addProduct: "Produkt hinzufügen",
        updateProduct: "Produkt aktualisieren",
        orderDetails: "Bestelldetails",
        openingHours: "Öffnungszeiten",
        paymentMethods: "Zahlungsmethoden",
        generalInfo: "Allgemeine Informationen",
        addDeliveryZone: "Lieferzone hinzufügen",
        updateDeliveryZone: "Lieferzone aktualisieren",
        customerList: "Kundenliste",
        addCustomer: "Kunde hinzufügen",
        customerDetails: "Kundendetails",
        ingredientList: "Zutatenliste",
        ingredientTypeList: "Zutatentypen Liste",
        addIngredient: "Zutat hinzufügen",
        updateIngredient: "Zutat aktualisieren",
        timeSlotList: "Zeitslot-Liste",
        addUser: "Benutzer hinzufügen",
        updateUserInfo: "Meine Informationen aktualisieren",
        userList: "Benutzerliste",
        addCategory: "Kategorie hinzufügen",
        updateCategory: "Kategorie aktualisieren",
        categoryList: "Kategorienliste",
        productList: "Produktliste",
        createCoupon: "Gutschein erstellen",
        couponDetails: "Gutscheindetails",
        couponList: "Gutscheinliste",
        franchises: "Franchises",
        addProgram: "Programm hinzufügen",
        updateProgram: "Programm aktualisieren",
        referralLoyalty: "Empfehlung & Treue",
        deliveryZoneList: "Lieferzonen",
        postalCodes: "Postleitzahlen",
        notificationList: "Benachrichtigungsliste",
        sendNotification: "Benachrichtigung senden",
        notificationDetails: "Benachrichtigungsdetails",
        campaignList: "Kampagnenliste",
        addCampaign: "Kampagne hinzufügen",
        campaignDetails: "Kampagnendetails",
        restaurantList: "Restaurantliste",
        addRestaurant: "Restaurant hinzufügen",
        updateRestaurant: "Aktualisieren",
        ingredientBaseList: "Basiszutatenliste",
        transactionDetails: "Transaktionsdetails",
        orders: "Bestellungen",
        transactions: "Transaktionen",
        configureOpeningHours: "Öffnungszeiten konfigurieren",
        configureOpeningHoursSubtitle: "Definieren Sie die Öffnungstage und -zeiten Ihres Restaurants",
        saveOpeningHours: "Zeiten speichern",
        optionalBreak: "Pause (optional)",
        openingDays: "Öffnungstage",
        open: "Geöffnet",
        partialOpen: "Teilweise geöffnet",
        detailedHours: "Detaillierte Stunden",
        opening: "Öffnung",
        start: "Beginn",
        end: "Ende",
        break: "Pause",
        breakStart: "Pausenbeginn",
        breakEnd: "Pausenende",
        addHours: "Stunden hinzufügen",
        addBreak: "Pause hinzufügen",
        removeHours: "Stunden entfernen",
        removeBreak: "Pause entfernen",
        dayStatus: "Tagesstatus",
        descriptionForDay: "Beschreibung für {dayLabel}",
        daysOfWeek: {
            monday: "Montag",
            tuesday: "Dienstag",
            wednesday: "Mittwoch",
            thursday: "Donnerstag",
            friday: "Freitag",
            saturday: "Samstag",
            sunday: "Sonntag",
        },
        resetPassword: "Passwort zurücksetzen",
        emailConfirmation: "E-Mail-Bestätigung",
        forgotPassword: "Passwort vergessen",
        register: "Registrieren",
        addTimeSlot: "Zeitslot hinzufügen",
        updateTimeSlot: "Zeitslot aktualisieren",
        thisWeek: "Diese Woche",
        thisMonth: "Dieser Monat",
        thisYear: "Dieses Jahr",
        addTimeRange: "Zeitspanne hinzufügen",
        timeRange: "Zeitspanne",
        deliverySlotConfig: "Lieferzeitslot-Konfiguration",
        active: "Aktiv",
        inactive: "Inaktiv",
        selected: "Ausgewählt",
        selectDayToConfigureHours: "Klicken Sie auf einen geöffneten Tag, um dessen detaillierte Stunden zu konfigurieren",
        configureTimeRangesForDay: "Konfigurieren Sie die Zeitspannen für diesen Tag",
        noTimeRanges: "Keine Zeitspannen konfiguriert",
    },
    customer: {
        averageBasket: "Durchschnittlicher Warenkorb",
        orderChannelsBreakdown: "Aufschlüsselung der Bestellkanäle",
        customerSpecification: "KUNDENSPEZIFIKATION",
        registeredAddressesList: "Liste der registrierten Adressen",
        remark: "Bemerkung",
        noRegisteredAddresses: "Keine registrierten Adressen.",
        orderAnalysis: "Analyse bei Bestellungen",
        specificAttentionPoints: "Spezifische Aufmerksamkeitspunkte",
        enterAttentionPoints: "Aufmerksamkeitspunkte eingeben...",
        orderTypesHistory: "Bestelltyp-Historie",
        cutleryRequestDuringOrders: "Besteckanfrage bei Bestellungen",
        clientPaymentHabits: "Zahlungsgewohnheiten des Kunden",
        totalOrdersNumber: "Gesamtzahl der Bestellungen",
        orderHistoryTable: "Bestellhistorie-Tabelle",
        orderHistory: "Bestellhistorie",
        primarilyOrdersType: "Der Kunde bestellt hauptsächlich Bestellungen vom Typ \"{type}\" ({count}/{total}).",
        varietyOrderTypes: "Der Kunde zeigt eine Vielzahl von Bestelltypen. Dominanter Typ: \"{type}\" ({count}/{total}).",
        alwaysRequestsCutlery: "Der Kunde fordert systematisch Besteck bei seinen Bestellungen an.",
        neverRequestsCutlery: "Der Kunde fordert niemals Besteck an.",
        majorityRequestsCutlery: "Der Kunde fordert in der Mehrheit der Fälle Besteck an.",
        rarelyRequestsCutlery: "Der Kunde fordert selten Besteck an.",
        requestsCutleryAmount: "Der Kunde fordert {amount} Besteckteil(e) bei seinen Bestellungen an.",
        exclusivelyUsesPaymentMethod: "Der Kunde verwendet ausschließlich die Zahlungsmethode \"{method}\".",
    },
    posClient: {
        title: "Client POS",
        description: "Dieser Kunde wird standardmäßig für Bestellungen verwendet, die über das POS aufgegeben werden, wenn kein Kunde ausgewählt ist.",
        add: "Einen POS-Kunden hinzufügen",
        edit: "Einen POS-Kunden bearbeiten",
        delete: "Einen POS-Kunden löschen",
        confirmDelete: "Sind Sie sicher, dass Sie diesen POS-Kunden löschen möchten?",
        saved: "Client POS erfolgreich gespeichert",
        deleted: "Client POS erfolgreich gelöscht",
        notFound: "Client POS nicht gefunden",
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail (optional)",
        phone: "Téléphone",
        civility: "Civilité",
    },
    loyalty: {
        totalReferralsInRange: "Gesamtzahl der Empfehlungen in diesem Zeitraum",
        reportTitle: "Treuepunkte-Journal",
        reportCustomer: "KUNDE",
        reportAction: "AKTION",
        reportPoints: "PUNKTE",
        reportBalance: "SOLDE",
        reportDate: "Datum",
        reportLastActivity: "Letzte Aktivität",
        earn: "Verdient",
        spend: "Ausgegeben",
        reverse: "Storniert",
        expired: "Abgelaufen",
        adjustPoints: "Punkte anpassen",
        reverseTransaction: "Transaktion stornieren",
        reverseSuccess: "Transaktion erfolgreich storniert",
        adjustSuccess: "Punkte erfolgreich angepasst",
        reason: "Grund",
        amount: "Betrag",
        confirmReverse: "Möchten Sie diese Transaktion wirklich stornieren?",
        confirmAdjust: "Möchten Sie die Punkte dieses Kunden wirklich anpassen?",
        referralReport: "Empfehlungsbericht",
        topReferrers: "Beste Empfehler",
        referrer: "Empfehler",
        referee: "Empfohlener",
        referralDate: "Empfehlungsdatum",
        pointsEarned: "Erhaltene Punkte",
        rewardStatus: "Prämienstatus",
        rewarded: "Belohnt",
        pending: "Ausstehend",
        searchReferral: "Suche nach Empfehler oder Empfohlenem...",
        referralDetails: "Empfehlungsdetails",
        noReferrals: "Keine Empfehlungen für diesen Zeitraum gefunden.",
        totalReferrals: "Gesamt Empfehlungen",
        totalPoints: "Gesamt Punkte"
    },
};
